<template>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM11 7.05115C11 6.49886 11.4477 6.05115 12 6.05115C12.5523 6.05115 13 6.49886 13 7.05115C13 7.60343 12.5523 8.05115 12 8.05115C11.4477 8.05115 11 7.60343 11 7.05115ZM12 9.97937C11.4477 9.97937 11 10.4271 11 10.9794V16.9794C11 17.5317 11.4477 17.9794 12 17.9794C12.5523 17.9794 13 17.5317 13 16.9794V10.9794C13 10.4271 12.5523 9.97937 12 9.97937Z"
  />
</template>
